import './MapLocationPin.css';

export const DEFAULT_LOCATION_PIN_SCALE = 0.72;

function pinGroupTransform({ x, y, scale }) {
  return `translate(${x.toFixed(2)} ${y.toFixed(2)}) scale(${scale})`;
}

function MapLocationPinArt() {
  return (
    <>
      <ellipse
        cx="0"
        cy="19"
        rx="12.5"
        ry="5"
        className="map-location-pin__shadow"
      />
      <path
        d="M 0 21 C -4.2 14.5 -9 8.6 -12.6 2.2 C -15.4 -2.8 -17 -7.3 -17 -11.1 C -17 -20.6 -9.4 -28 0 -28 C 9.4 -28 17 -20.6 17 -11.1 C 17 -7.3 15.4 -2.8 12.6 2.2 C 9 8.6 4.2 14.5 0 21 Z"
        className="map-location-pin__body"
      />
      <path
        d="M 0 21 C 4.2 14.5 9 8.6 12.6 2.2 C 15 -2.1 16.6 -6 16.9 -9.4 L 0 6.6 Z"
        className="map-location-pin__facet"
      />
      <path
        d="M 0 -23.6 C 6.3 -23.6 11.5 -20.1 13.6 -14.7 C 10.8 -18.1 5.9 -20 0 -20 C -5.7 -20 -10.6 -18.2 -13.3 -15 C -11.2 -20.2 -6.1 -23.6 0 -23.6 Z"
        className="map-location-pin__highlight"
      />
      <circle
        cx="0"
        cy="-10.7"
        r="6.6"
        className="map-location-pin__core"
      />
    </>
  );
}

export function SvgLocationPin({
  pin,
  scale = DEFAULT_LOCATION_PIN_SCALE,
  className = '',
}) {
  if (!pin) return null;

  const rootClassName = ['map-location-pin', className].filter(Boolean).join(' ');

  return (
    <g
      className={rootClassName}
      transform={pinGroupTransform({
        x: pin.x,
        y: pin.y,
        scale,
      })}
      aria-label={pin.ariaLabel}
    >
      <MapLocationPinArt />
    </g>
  );
}

export function HtmlLocationPinMarker({
  className = '',
  style,
  dataTestId,
  ariaLabel,
  ariaHidden = true,
}) {
  const rootClassName = ['map-location-pin-marker', className].filter(Boolean).join(' ');
  const accessibilityProps = ariaHidden
    ? { 'aria-hidden': 'true' }
    : { 'aria-label': ariaLabel };

  return (
    <div
      className={rootClassName}
      style={style}
      data-testid={dataTestId}
      {...accessibilityProps}
    >
      <svg
        className="map-location-pin-marker__svg"
        viewBox="-20 -31 40 58"
        focusable="false"
        aria-hidden="true"
      >
        <g className="map-location-pin">
          <MapLocationPinArt />
        </g>
      </svg>
    </div>
  );
}
